import styled from "styled-components";

const MenuDivider = styled.div`
  margin: var(--ads-spaces-1) var(--ads-spaces-6);
  border-top: 1px solid var(--ads-menu-divider-border-color);
`;

export default MenuDivider;
